import { ApiJobFunction } from 'api/types/ApiJobFunction';
import { getJson } from 'utils/http';

export function apiFetchJobFunctions(): Promise<ApiJobFunction[]> {
  return getJson(`/data/website/job-functions?lang=${CURRENT_LOCALE}`).then(
    // @ts-expect-error TS(2345): Argument of type '({ jobFunctions }: { jobFunction... Remove this comment to see the full error message
    ({ jobFunctions }) => jobFunctions,
  );
}
